import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonagpurcabs() {



const cardData = {
  keyword: "Pune To Nagpur Cabs",
  heading: "Lotus Cab: Pune To Nagpur Cabs",

  headingDescription:
    "Lotus Cab offers reliable Pune To Nagpur Cabs for safe and comfortable long-distance travel across Maharashtra. Whether you are planning a corporate visit, family vacation, religious tour, or business relocation, our well-maintained AC sedans and spacious SUVs ensure a smooth journey. Nagpur is approximately 700+ km from Pune, requiring experienced highway drivers, and our trained chauffeurs ensure safe interstate travel. Transparent per kilometer pricing with one-way and round-trip options is available. Flexible departure scheduling and 24/7 booking support make planning easy. With punctual pickup from anywhere in Pune, we provide stress-free and dependable travel to Nagpur.",

  top: "Top Places to Visit in Nagpur with Lotus Cab",

  topPlaces: [
    {
      title: "Deekshabhoomi",
      description:
        "Deekshabhoomi is one of the most important Buddhist pilgrimage sites in India. It is the place where Dr. B.R. Ambedkar embraced Buddhism along with thousands of followers. The grand stupa attracts visitors from across the country. The peaceful environment makes it spiritually uplifting. It is a must-visit landmark in Nagpur. Comfortable cab travel makes sightseeing convenient."
    },
    {
      title: "Sitabuldi Fort",
      description:
        "Sitabuldi Fort is a historic fort located in the heart of Nagpur city. It holds significance from the British era. Visitors enjoy panoramic city views from the top. It is a prominent heritage attraction. History enthusiasts frequently visit this site. Reliable cab service ensures easy access."
    },
    {
      title: "Futala Lake",
      description:
        "Futala Lake is a popular leisure destination in Nagpur. It is known for evening lighting and peaceful atmosphere. Families enjoy relaxing near the waterfront. The sunset view is particularly beautiful. Local food stalls add charm to the area. Comfortable taxi travel makes the visit smooth."
    },
    {
      title: "Ambazari Lake and Garden",
      description:
        "Ambazari Lake is one of the largest lakes in Nagpur. The nearby garden offers boating and recreational activities. It is ideal for family outings and relaxation. Visitors enjoy green surroundings and fresh air. It is a refreshing spot in the city. Safe cab service ensures comfortable travel."
    },
    {
      title: "Raman Science Centre",
      description:
        "Raman Science Centre is an educational and interactive attraction. It is popular among students and families. Exhibits focus on science and innovation. The planetarium is a major highlight. It promotes learning and entertainment together. Cab travel makes it easily accessible."
    },
    {
      title: "Maharaj Bagh Zoo",
      description:
        "Maharaj Bagh Zoo is a family-friendly attraction in Nagpur. It houses various animals and botanical gardens. Children especially enjoy visiting this place. It is centrally located in the city. A short cab ride makes travel convenient. Ideal for family sightseeing."
    },
    {
      title: "Zero Mile Stone",
      description:
        "Zero Mile Stone marks the geographical center of India. It is a significant landmark in Nagpur. Travelers often stop here for photographs. It symbolizes Nagpur’s central location. It is an iconic attraction for tourists. Comfortable taxi travel ensures easy visit."
    },
    {
      title: "Pench National Park",
      description:
        "Pench National Park is located near Nagpur and is famous for wildlife safaris. It inspired the Jungle Book. Visitors enjoy tiger spotting and nature trails. It is ideal for wildlife enthusiasts. SUV vehicles are recommended for such trips. Reliable long-distance cab service makes travel safe."
    }
  ],

  services: [
    {
      name: "Pune to Nagpur Taxi Service",
      description:
        "Professional taxi service from Pune to Nagpur with experienced interstate drivers. Safe and smooth highway journey ensured. AC sedans and SUVs available. Transparent per km pricing maintained. Suitable for business and family travel. Comfortable long-distance ride guaranteed."
    },
    {
      name: "Pune to Nagpur One Way Cab",
      description:
        "One-way cab service allows payment only for drop distance. Ideal for relocation or airport transfer. Affordable pricing maintained. Clean and comfortable vehicles provided. Transparent billing policy followed. Convenient single-side travel option."
    },
    {
      name: "Pune to Nagpur Round Trip Taxi",
      description:
        "Round-trip taxi offers flexible return scheduling. Suitable for multi-day business or family visits. Experienced drivers ensure safe travel. Comfortable SUV options available. Transparent pricing maintained. Reliable return journey guaranteed."
    },
    {
      name: "Affordable Pune to Nagpur Cab",
      description:
        "Budget-friendly long-distance cab service. Clear fare breakdown shared before booking. No hidden charges applied. Comfortable sedan options available. Ideal for cost-conscious travelers. Reliable service ensured."
    },
    {
      name: "Luxury Taxi Pune to Nagpur",
      description:
        "Premium vehicle options available for executive travel. Plush seating enhances long journey comfort. Professional chauffeurs ensure punctuality. Suitable for VIP and corporate clients. Well-maintained luxury cars provided. Stress-free premium travel experience."
    },
    {
      name: "SUV Cab Pune to Nagpur",
      description:
        "Spacious SUV vehicles ideal for family and group travel. Extra luggage space available. Safe interstate highway driving ensured. Comfortable interiors maintained. Suitable for extended trips. Smooth travel guaranteed."
    },
    {
      name: "Online Cab Booking Pune to Nagpur",
      description:
        "24/7 online cab booking available with quick confirmation. Transparent fare estimation displayed. Flexible departure scheduling supported. Multiple vehicle options available. Secure booking process ensured. Hassle-free travel planning."
    },
    {
      name: "Pune to Nagpur Corporate Cab",
      description:
        "Professional corporate cab service for business travel. Executive sedan options available. On-time pickup guaranteed. Transparent billing maintained. Reliable interstate journey ensured. Ideal for official visits."
    }
  ],

  tableData: [
    ["Pune To Nagpur Cabs", "Pune to Nagpur Taxi Service"],
    ["Pune to Nagpur One Way Cab", "Pune to Nagpur Round Trip Taxi"],
    ["Pune to Nagpur Outstation Cab", "Affordable Pune to Nagpur Cab"],
    ["Luxury Taxi Pune to Nagpur", "SUV Cab Pune to Nagpur"],
    ["Cheap Pune to Nagpur Taxi", "Online Cab Booking Pune to Nagpur"],
    ["Best Cab Service Pune to Nagpur", "Pune to Nagpur Corporate Cab"],
    ["Pune to Nagpur Family Trip Taxi", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Interstate Drivers",
      WhyChoosedescription:
        "Our drivers are trained for long-distance interstate travel. Safe highway driving ensured. Familiar with Maharashtra routes. Smooth and secure journey maintained."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear per kilometer fare structure maintained. No hidden charges applied. Toll and allowance explained beforehand. Complete cost transparency ensured."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Sedan and SUV options available. Suitable for families and corporate travel. Clean and well-maintained fleet ensured. Comfortable interiors provided."
    },
    {
      WhyChooseheading: "Flexible Travel Options",
      WhyChoosedescription:
        "One-way and round-trip bookings available. Flexible departure timing supported. Multi-day stay planning possible. Easy booking process ensured."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock assistance available. Immediate booking confirmation provided. Quick response to travel queries ensured."
    },
    {
      WhyChooseheading: "Corporate Travel Expertise",
      WhyChoosedescription:
        "Executive vehicles available for business trips. Punctual scheduling maintained. Transparent billing provided. Professional service ensured."
    },
    {
      WhyChooseheading: "Family-Friendly Service",
      WhyChoosedescription:
        "Spacious vehicles suitable for family groups. Safe driving ensured. Comfortable long-distance travel experience."
    },
    {
      WhyChooseheading: "Reliable & Trusted Service",
      WhyChoosedescription:
        "On-time pickup guaranteed. Well-maintained vehicles provided. Stress-free long-distance journey ensured."
    }
  ]
};

const faqData = [
  { question: "How far is Nagpur from Pune?", answer: "Nagpur is approximately 700-720 km from Pune and travel time is around 12-14 hours depending on traffic." },
  { question: "Do you provide one-way cab to Nagpur?", answer: "Yes, one-way cab service is available with transparent single-side pricing." },
  { question: "Are SUVs recommended for Pune to Nagpur travel?", answer: "SUVs are recommended for family and group travel due to comfort and luggage space." },
  { question: "Is round-trip taxi available?", answer: "Yes, round-trip option is available with flexible return scheduling." },
  { question: "Is night travel available?", answer: "Yes, 24/7 cab service is available including overnight travel." },
  { question: "Are toll charges included?", answer: "Toll charges are shared transparently before booking confirmation." },
  { question: "Is online booking available?", answer: "Yes, online cab booking is available 24/7 with quick confirmation." },
  { question: "Do you provide corporate billing?", answer: "Yes, corporate billing options are available for official travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel planning." },
  { question: "What vehicle options are available?", answer: "Sedan and SUV categories are available depending on comfort and group size." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Deshmukh",
    feedback:
      "Our Pune to Nagpur family trip was very comfortable. Driver handled long-distance travel smoothly. Transparent fare and clean vehicle impressed us. Highly recommend Lotus Cab for interstate journeys.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Sharma",
    feedback:
      "Booked SUV for Nagpur trip. Spacious seating and safe driving ensured relaxed travel. Pricing was clear with no hidden charges. Excellent service quality.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rohit Mehta",
    feedback:
      "Corporate trip to Nagpur was professionally managed. On-time pickup and executive sedan provided. Reliable and comfortable travel experience.",
    rating: 5
  }
];






















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nagpur Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-nagpur-cabs.jpg", 
  "description": "Lotus Cab offers Pune to Nagpur cabs with affordable one way and round trip taxi services. Book sedan, SUV, and luxury outstation cabs for corporate travel, family trips, and comfortable long-distance journeys with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-nagpur-cabs"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Nagpur Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Nagpur cabs with Lotus Cab. Affordable one way & round trip taxi for corporate, family & long-distance travel. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Nagpur Cabs, Pune to Nagpur Taxi Service, Pune to Nagpur One Way Cab, Pune to Nagpur Round Trip Taxi, Pune to Nagpur Outstation Cab, Affordable Pune to Nagpur Cab, Luxury Taxi Pune to Nagpur, SUV Cab Pune to Nagpur, Cheap Pune to Nagpur Taxi, Online Cab Booking Pune to Nagpur, Best Cab Service Pune to Nagpur, Pune to Nagpur Corporate Cab, Pune to Nagpur Family Trip Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonagpurcabs;